import PropTypes from 'prop-types';
import React from 'react';

import omit from 'lodash/omit';
import {Alert, AlertTitle, Box, CircularProgress} from '@mui/material';
import {SnackbarContent, useSnackbar} from 'notistack';
import {useTranslation} from 'react-i18next';

export const AlertSnackbar = React.forwardRef(
  ({closeButton = true, message, progress, title, variant, ...props}, ref) => {
    const {t} = useTranslation();
    const {closeSnackbar} = useSnackbar();

    const localizedTitle = !title?.i18nKey
      ? title
      : t(title.i18nKey, omit(title, 'i18nKey'));
    const localizedMessage = !message?.i18nKey
      ? message
      : t(message.i18nKey, omit(message, 'i18nKey'));

    const onClose = () => {
      closeSnackbar(props.id);
    };

    return (
      <SnackbarContent ref={ref}>
        <Alert
          icon={false}
          elevation={2}
          onClose={!progress && closeButton ? onClose : undefined}
          color={variant === 'info' ? 'primary' : null}
          severity={variant}
          variant="filled"
        >
          {localizedTitle && <AlertTitle>{localizedTitle}</AlertTitle>}
          <Box display="flex" alignItems="center">
            {progress && (
              <CircularProgress
                color="inherit"
                size={22}
                sx={{marginRight: 2}}
              />
            )}
            {localizedMessage && localizedMessage}
          </Box>
        </Alert>
      </SnackbarContent>
    );
  }
);

AlertSnackbar.propTypes = {
  message: PropTypes.node,
  onClose: PropTypes.func,
  title: PropTypes.string,
  progress: PropTypes.bool,
  closeButton: PropTypes.bool,
  variant: PropTypes.string,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default AlertSnackbar;
